/**
 * @generated SignedSource<<6542982413b48966a4eeab877d1e272e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WithWalletConnectionEnsured_viewer$data = {
  readonly walletConnectEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectWalletContent_viewer" | "ConnectWalletWithSigningContent_viewer" | "ConnectWalletWithSigningNoZipContent_viewer" | "MismatchedAddressContent_viewer" | "UnsupportedBrowserContent_viewer" | "UnsupportedChainContent_viewer" | "useWalletConnectionEnsured_viewer">;
  readonly " $fragmentType": "WithWalletConnectionEnsured_viewer";
};
export type WithWalletConnectionEnsured_viewer$key = {
  readonly " $data"?: WithWalletConnectionEnsured_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"WithWalletConnectionEnsured_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WithWalletConnectionEnsured_viewer",
  "selections": [
    {
      "alias": "walletConnectEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "allowWalletConnect"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useWalletConnectionEnsured_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UnsupportedBrowserContent_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UnsupportedChainContent_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MismatchedAddressContent_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectWalletWithSigningContent_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectWalletWithSigningNoZipContent_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectWalletContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "27a0287882e1c3ecb99cc4b60d3c84be";

export default node;
